// Extracts the HTTP status code from the various error shapes our sync/upload paths produce, so
// callers can classify a 4xx (terminal) apart from a 5xx / no-response (transient) consistently.
//
//   - axios errors:          error.response.status
//   - uppy Companion calls:  error.status, set by our @uppy/aws-s3 patch (patches/@uppy__aws-s3.patch)
//                            on a failed /s3/multipart request (create, sign part, list, complete, abort)
//   - uppy S3 part upload:   error.request.status - @uppy/core's fetcher wraps every non-2xx in a
//                            NetworkError that carries the XHR; 0 means no response at all
//   - uppy 5 shapes:         error.source.status (part upload), error.cause.statusCode and the
//                            "Failed request with status: 400" cause message of the old RequestClient
//                            wrapper. No longer produced live, but kept for persisted errors.
//
// Without the message fallback a terminal 4xx that lost its structured status looks statusless and
// gets misread as a transient network problem by is-network-error's message heuristic.

const parseStatusFromMessage = (message) => {
  if (typeof message !== 'string') {
    return undefined
  }

  const match = message.match(/(?:failed request with status|failed with status):?\s*(\d+)/i)

  return match
    ? Number(match[1])
    : undefined
}

const getErrorStatus = (error) => {
  if (!error || typeof error === 'string') {
    return undefined
  }

  return error.response?.status ??
    error.status ??
    (error.request?.status || undefined) ??
    error.source?.status ??
    error.statusCode ??
    error.cause?.statusCode ??
    parseStatusFromMessage(error.message) ??
    parseStatusFromMessage(error.cause?.message)
}

export default getErrorStatus
